/**
 * @generated SignedSource<<da79c68d2c0d2bd5cd715b3dcd06b6e1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Service",
    "kind": "LinkedField",
    "name": "serviceById",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tags",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "topServiceByIdQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "topServiceByIdQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "96fc948ee0dedde1437744526f1d9f12",
    "id": null,
    "metadata": {},
    "name": "topServiceByIdQuery",
    "operationKind": "query",
    "text": "query topServiceByIdQuery(\n  $id: String\n) {\n  serviceById(id: $id) {\n    id\n    tags\n  }\n}\n"
  }
};
})();

node.hash = "e8110d01a7d5972ce71213f15877878d";

module.exports = node;
